/* Joe Clinic: product return navigation and contact-form validation, 2026-09-09.
 * Normal Shopify contact POST and CAPTCHA are retained. No personal data is
 * written to URLs, analytics, or localStorage. Existing yes/no routing is kept.
 */
(function () {
  'use strict';
  if (window.__joeCounselingFlowV1) return;
  window.__joeCounselingFlowV1 = true;
  var MAX_AGE = 2 * 60 * 60 * 1000;

  function readState(key) {
    try {
      var value = JSON.parse(window.sessionStorage.getItem(key));
      return value && typeof value.at === 'number' && Date.now() - value.at >= 0 &&
        Date.now() - value.at < MAX_AGE ? value : null;
    } catch (error) { return null; }
  }
  function writeState(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (error) { /* Storage may be blocked. */ }
  }
  function removeState(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) { /* Keep the form usable. */ }
  }

  // Return only to an actual product route on this storefront, never an external URL.
  function productPath(raw) {
    if (typeof raw !== 'string' || !raw || raw.length > 2048 || /[\\\u0000-\u001f]/.test(raw)) return '';
    try {
      var url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      var decoded = decodeURIComponent(url.pathname);
      if (/[\\\u0000-\u001f]/.test(decoded) || /%2f|%5c/i.test(url.pathname)) return '';
      if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(?:\/collections\/[^/]+)?\/products\/[^/]+\/?$/i.test(decoded)) return '';
      var result = url.pathname;
      var variant = url.searchParams.get('variant');
      if (variant && /^\d+$/.test(variant)) result += '?variant=' + variant;
      return result;
    } catch (error) { return ''; }
  }

  function updateProductLink(link) {
    var source = productPath(link.getAttribute('data-product-url'));
    if (!source) return;
    var product = new URL(source, window.location.origin);
    var scope = link.closest('[data-product-id]') || link.closest('.shopify-section');
    var variantInput = scope && scope.querySelector('form[action*="/cart/add"] [name="id"]');
    var current = new URL(window.location.href);
    var variant = variantInput && variantInput.value || current.searchParams.get('variant') || product.searchParams.get('variant');
    if (variant && /^\d+$/.test(variant)) product.searchParams.set('variant', variant);
    var target = new URL(link.getAttribute('href'), window.location.origin);
    if (target.origin !== window.location.origin) return;
    target.searchParams.set('return_product', productPath(product.href));
    var preview = current.searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
    link.href = target.pathname + target.search;
  }
  // Delegation also handles dynamically re-rendered product sections.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-jc-counseling-link]');
    if (link) updateProductLink(link);
  }, true);
  document.addEventListener('change', function () {
    document.querySelectorAll('a[data-jc-counseling-link]').forEach(updateProductLink);
  });

  function initForm(root) {
    if (root.dataset.cfReady === 'true') return;
    var form = root.querySelector('form.cf-form');
    var email = form && form.querySelector('[name="contact[email]"]');
    if (!form || !email) return;
    root.dataset.cfReady = 'true';
    var sectionId = root.getAttribute('data-cf-section');
    var stateKey = 'jc-cf-pending-' + sectionId;
    var returnKey = 'jc-cf-return-' + sectionId;
    var oldKey = 'cf-applicable-' + sectionId;
    var server = form.querySelector('[data-cf-server-state]');
    var serverErrors = server && server.dataset.errors === 'true';
    var serverSuccess = server && server.dataset.success === 'true';
    var url = new URL(window.location.href);
    var pending = readState(stateKey);
    var storedReturn = readState(returnKey);
    var origin = productPath(url.searchParams.get('return_product'));
    if (!origin && (serverErrors || serverSuccess || url.searchParams.get('contact_posted') === 'true')) {
      origin = productPath(pending && pending.product) || productPath(storedReturn && storedReturn.product);
    }
    if (origin) writeState(returnKey, { product: origin, at: Date.now() });
    else if (!pending) removeState(returnKey);
    var fallback = root.getAttribute('data-cf-fallback') || '/collections/all';
    var destination = origin || fallback;
    var preview = url.searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) {
      var previewDestination = new URL(destination, window.location.origin);
      previewDestination.searchParams.set('preview_theme_id', preview);
      destination = previewDestination.pathname + previewDestination.search;
    }
    root.querySelectorAll('[data-cf-return]').forEach(function (link) {
      link.href = destination;
      link.textContent = origin ? '先ほどの商品に戻る' : '商品一覧を見る';
    });

    // Carry product context through Shopify's native redirect/CAPTCHA flow.
    var returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) {
      var successURL = new URL(root.getAttribute('data-cf-form-url') || '/pages/counseling-form', window.location.origin);
      successURL.searchParams.set('contact_posted', 'true');
      if (origin) successURL.searchParams.set('return_product', origin);
      if (preview && /^\d+$/.test(preview)) successURL.searchParams.set('preview_theme_id', preview);
      returnTo.value = successURL.pathname + successURL.search;
    }

    var inlineError = root.querySelector('[data-cf-email-error]');
    var clientError = root.querySelector('[data-cf-client-error]');
    var status = root.querySelector('[data-cf-status]');
    var submit = form.querySelector('.cf-btn-submit');
    var timer;
    var originalLabel = submit.textContent;
    function announceError(message) {
      clientError.textContent = message;
      clientError.hidden = false;
      clientError.focus();
    }
    function emailError() {
      var message = !email.value.trim() ? 'メールアドレスを入力してください。' :
        'メールアドレスの形式を確認してください。例：name@example.com（半角で入力）';
      inlineError.textContent = message;
      inlineError.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
    }
    email.addEventListener('invalid', function (event) {
      event.preventDefault();
      emailError();
    });
    email.addEventListener('input', function () {
      email.removeAttribute('aria-invalid');
      inlineError.hidden = true;
      clientError.hidden = true;
    });
    email.addEventListener('blur', function () { email.value = email.value.trim(); });

    function resetButton() {
      clearTimeout(timer);
      submit.disabled = false;
      submit.textContent = originalLabel;
      form.removeAttribute('aria-busy');
      status.hidden = true;
    }
    window.addEventListener('pageshow', resetButton);
    form.addEventListener('submit', function (event) {
      email.value = email.value.trim();
      if (!email.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        emailError();
        return;
      }
      if (window.navigator.onLine === false) {
        event.preventDefault();
        event.stopImmediatePropagation();
        announceError('インターネットに接続できません。通信環境を確認してから、もう一度「送信する」を押してください。');
        return;
      }
      clientError.hidden = true;
      var lastName = form.querySelector('[name="last_name"]').value;
      var firstName = form.querySelector('[name="first_name"]').value;
      var phone = form.querySelector('[name="contact[phone]"]').value;
      var carteNumber = form.querySelector('[name="carte_number"]').value;
      var applicable = form.querySelector('input[name="applicable"]:checked');
      // Preserve the existing optional-Q6 routing. This is not a new eligibility decision.
      var applicableValue = applicable ? applicable.value : 'no';
      var applicableLabel = !applicable ? '未回答' : applicable.value === 'yes' ? '該当する' : '該当しない';
      form.querySelector('[name="contact[name]"]').value = (lastName + ' ' + firstName).trim();
      form.querySelector('[name="contact[body]"]').value = [
        '姓: ' + lastName, '名: ' + firstName, 'メールアドレス: ' + email.value,
        '電話番号: ' + phone, 'カルテナンバー: ' + carteNumber,
        '以下に一つでも該当しますか: ' + applicableLabel
      ].join('\n');
      writeState(stateKey, { applicable: applicableValue, product: origin, at: Date.now() });
      // Keep the normal POST. A CAPTCHA handler may prevent this attempt and resume it later.
      setTimeout(function () {
        if (event.defaultPrevented) return;
        submit.disabled = true;
        submit.textContent = '送信中…';
        form.setAttribute('aria-busy', 'true');
        status.textContent = '送信しています。認証画面が表示された場合は、画面の案内に従ってください。';
        status.hidden = false;
        timer = setTimeout(function () {
          resetButton();
          announceError('送信完了をまだ確認できていません。認証画面がある場合は先に完了してください。通信状況を確認し、同じ内容を続けて送信しないようご注意ください。');
        }, 30000);
      }, 0);
    }, true);
    var cancel = root.querySelector('.cf-btn-cancel');
    if (cancel) cancel.addEventListener('click', function () { window.location.assign(destination); });

    // Server errors always take precedence over a success query parameter.
    if (serverErrors) {
      removeState(stateKey);
      var summary = root.querySelector('[data-cf-server-errors]');
      if (summary) summary.focus();
    } else if (serverSuccess || (url.searchParams.get('contact_posted') === 'true' && pending)) {
      var applicableValue = pending && pending.applicable;
      if (!applicableValue) {
        try { applicableValue = window.sessionStorage.getItem(oldKey); } catch (error) { /* Optional state. */ }
      }
      var formSection = root.querySelector('[data-cf-form-section]');
      var result = root.querySelector(applicableValue === 'yes' ? '[data-cf-result="yes"]' : '[data-cf-result="no"]');
      if (formSection && result) {
        formSection.style.display = 'none';
        result.style.display = 'block';
        result.setAttribute('tabindex', '-1');
        result.focus();
      }
      removeState(stateKey);
      removeState(oldKey);
      // Keep the safe origin in the URL so a reload does not lose the return button.
      url.searchParams.delete('contact_posted');
      try { window.history.replaceState(null, '', url.pathname + url.search + url.hash); } catch (error) { /* Ignore. */ }
    }

    root.querySelectorAll('.cf-pw-copy').forEach(function (copyButton) {
      copyButton.addEventListener('click', function () {
        var message = copyButton.querySelector('.cf-pw-copied-msg');
        var value = copyButton.getAttribute('data-password');
        function finish(ok) {
          copyButton.classList.toggle('is-copied', ok);
          message.textContent = ok ? 'コピーしました！' : 'コピーできませんでした。表示されたパスワードを選択してコピーしてください。';
        }
        function fallbackCopy() {
          var field = document.createElement('textarea');
          field.value = value;
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.focus(); field.select(); field.setSelectionRange(0, field.value.length);
          var ok = false;
          try { ok = document.execCommand('copy'); } catch (error) { /* Manual copy remains available. */ }
          field.remove(); copyButton.focus(); finish(ok);
        }
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(value).then(function () { finish(true); }).catch(fallbackCopy);
        } else fallbackCopy();
      });
    });
  }
  function init() {
    document.querySelectorAll('a[data-jc-counseling-link]').forEach(updateProductLink);
    document.querySelectorAll('[data-cf-section]').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

